"use strict";

if (!window.Academia) {
  window.Academia = {};
}
window.Academia.openTwitterShareWindow = function (tweetText, shareUrl, via) {
  let windowUrl = "http://twitter.com/intent/tweet?text=" + encodeURIComponent(tweetText);
  if (shareUrl && shareUrl.length > 0) {
    windowUrl = windowUrl + "&url=" + encodeURIComponent(shareUrl);
  }
  if (via && via.length > 0) {
    windowUrl = windowUrl + "&via=" + encodeURIComponent(via);
  }
  const options = "toolbar=0,scrollbars=1,resizable=1,width=600,height=400";
  window.open(windowUrl, "", options);
};